import {Component} from "@angular/core";
import {TCITenantSelectorType} from "@tci/common";

import {AbstractTCITenantComponent} from "../../../ng-tenant/tci-tenant-component";
import {BaseAppExecHistoryListComponentInput, BaseAppExecHistoryListComponentOutput} from "../ng-app-exec-history/base-app-exec-history-list";

@Component({
    selector: TCITenantSelectorType.TCI_APP_DETAIL_EX_HST_LISTING.toString(),
    template: "<h1 style=\"text-align: center;\">BW or Flogo should extend BaseAppExecHistoryListComponent.</h1>"
})
export class BaseAppExecHistoryListComponent
    <E, I extends BaseAppExecHistoryListComponentInput, O extends BaseAppExecHistoryListComponentOutput<E>>
    extends AbstractTCITenantComponent<E, I, O> {

    constructor(
    ) {
        super();
    }
}
